import { theme } from '../../../../global-styles/colors';

export const ASSISTANCE_STATUS = {
  NULLED: 'A',
  CLOSED: 'C',
  IN_PROGRESS: 'P',
  FINISHED: 'R',
} as const;

export type AssistanceStatusColors = { background: string; color: string };

const STATUS_COLORS: Record<string, AssistanceStatusColors> = {
  [ASSISTANCE_STATUS.IN_PROGRESS]: {
    background: theme.status.info.info_background,
    color: theme.status.info.info_status,
  },
  [ASSISTANCE_STATUS.FINISHED]: { background: theme.status.success.light, color: theme.status.success.dark },
  [ASSISTANCE_STATUS.CLOSED]: { background: theme.status.alert.light, color: theme.status.alert.dark },
  [ASSISTANCE_STATUS.NULLED]: { background: theme.greys.grey010, color: theme.greys.grey080 },
};

export const getAssistanceStatusColors = (estado?: string): AssistanceStatusColors =>
  STATUS_COLORS[estado ?? ''] ?? STATUS_COLORS[ASSISTANCE_STATUS.IN_PROGRESS];
